// import produce from 'immer';
// @ts-nocheck
import { useEffect, useState } from 'react';
import { RJSFSchema } from '@rjsf/utils';
import addClientGroupForm from '../components/ClientGroups/addClientGroupForm.json';
import useClients from './useClients';

const useClientGroupAddForm = (currentClientId) => {
  const { clients, isLoading: isClientsLoading } = useClients();

  const [updated, setUpdated] = useState(false);
  const [addClientGroupFormSchema, setSchema] = useState<RJSFSchema>(
    addClientGroupForm as RJSFSchema
  );

  useEffect(() => {
    if (clients) {
      const allowedClients = Object.values(clients).filter(
        (client) => !client.GroupId && client.id !== parseInt(currentClientId)
      );

      const oneOf = [
        ...allowedClients.map((client: any) => ({
          const: client.id,
          title: client.ClientName,
        })),
      ];

      setSchema((schema) => {
        schema = Object.assign({}, schema, {
          properties: Object.assign({}, schema.properties, {
            ClientId: Object.assign({}, schema.properties.ClientId, {
              oneOf: oneOf,
            }),
          }),
        });

        return schema;
      });
      setUpdated(true);
    }
  }, [clients, currentClientId]);

  return {
    addClientGroupFormSchema,
    isLoading: isClientsLoading,
    updated,
  };
};
export default useClientGroupAddForm;
